// extracted by mini-css-extract-plugin
export default {"error":"src-containers-Cart-CartError--error"};